import { RouterConfig } from '@edikk-edikk/shared';
import { IntlShape } from 'react-intl';
import { FilterCityType } from '#advert/types/filter/FilterCityType';
import { FilterCategoryType } from '#advert/types/filter/FilterCategoryType';
import { FilterAreaType } from '#advert/types/filter/FilterAreaType';

class FilterItem {
  public readonly intl: IntlShape;

  public readonly url: string;

  public readonly name: string;

  public readonly key: string;

  public readonly routerConfig: RouterConfig;

  public readonly numberOfAdverts: number;

  constructor(
    intl: IntlShape,
    url: string,
    name: string,
    key: string,
    routerConfig: RouterConfig,
    numberOfAdverts: number,
  ) {
    this.intl = intl;
    this.url = url;
    this.name = name;
    this.key = key;
    this.routerConfig = routerConfig;
    this.numberOfAdverts = numberOfAdverts;
  }

  static initByArea(intl: IntlShape, area: FilterAreaType): FilterItem {
    let routerConfig = RouterConfig.initForRegion();
    if (area.areaId) {
      routerConfig = RouterConfig.initForArea(area.areaId);
    }

    return new this(
      intl,
      area.url,
      area.name,
      area.key,
      routerConfig,
      area.numberOfAdverts,
    );
  }

  static initByCity(intl: IntlShape, city: FilterCityType): FilterItem {
    let routerConfig = RouterConfig.initForRegion();
    if (city.areaId) {
      routerConfig = RouterConfig.initForArea(city.areaId);
    } else if (city.cityId) {
      routerConfig = RouterConfig.initForCity(city.cityId);
    }

    return new this(
      intl,
      city.url,
      city.name,
      city.key,
      routerConfig,
      city.numberOfAdverts,
    );
  }

  static initByCategory(intl: IntlShape, category: FilterCategoryType): FilterItem {
    let routerConfig = RouterConfig.initForCity(category.cityId);
    if (category.categoryId) {
      routerConfig = RouterConfig.initForCategoryInCity(category.categoryId, category.cityId);
    }

    return new this(
      intl,
      category.url,
      category.name,
      category.key,
      routerConfig,
      category.numberOfAdverts,
    );
  }

  getVisibleName(): string {
    if (this.name) {
      return this.name;
    }
    return this.intl.formatMessage({ defaultMessage: 'All escorts' });
  }
}

export { FilterItem };
